export default function Hero() {
  const scrollToWaitlist = () => {
    const element = document.getElementById('waitlist');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1d4946f856771c8ae9e0e9d5423e965e.jpg"
          alt="Kuala Lumpur Traffic Challenges"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center">
            <div className="inline-flex items-center bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-8">
              <span className="text-xs font-medium text-teal-300 mr-2" style={{ fontFamily: "'Inter', sans-serif" }}>
                Powered by AI
              </span>
              <span className="text-xs text-white/70" style={{ fontFamily: "'Inter', sans-serif" }}>
                •
              </span>
              <span className="text-xs text-white/90 ml-2" style={{ fontFamily: "'Inter', sans-serif" }}>
                Launching Q3 2026
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight max-w-4xl mx-auto" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Daily Carpooling for<br />
              <span className="text-teal-400">Same Destination Commuters</span>
            </h1>
            
            <p className="text-base md:text-lg text-white/90 mb-4 font-light max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
              Tired of traffic jams and unreliable public transport? <strong className="font-bold">KLCarPool</strong> connects drivers and passengers heading the same way every day — reducing costs, congestion, and carbon emissions across Kuala Lumpur.
            </p>
            
            <div className="flex flex-wrap gap-3 mb-8 justify-center">
              <span className="px-3 py-1 bg-white/10 backdrop-blur-sm rounded-full text-xs text-white/80" style={{ fontFamily: "'Inter', sans-serif" }}>
                Daily / Weekly / Monthly Plans
              </span>
              <span className="px-3 py-1 bg-white/10 backdrop-blur-sm rounded-full text-xs text-white/80" style={{ fontFamily: "'Inter', sans-serif" }}>
                Women-Only Option
              </span>
              <span className="px-3 py-1 bg-white/10 backdrop-blur-sm rounded-full text-xs text-white/80" style={{ fontFamily: "'Inter', sans-serif" }}>
                AI Route Matching
              </span>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center">
              <button
                onClick={scrollToWaitlist}
                className="inline-flex items-center px-8 py-4 bg-teal-600 text-white rounded-full text-base font-medium hover:bg-teal-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                Join Waitlist
                <i className="ri-arrow-right-line ml-2 text-xl w-5 h-5 flex items-center justify-center"></i>
              </button>
              
              <a
                href="https://wa.me/60123835600?text=Hi%2C%20I%27d%20like%20to%20join%20the%20waitlist%20for%20KLCarPool"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-8 py-4 border-2 border-white/30 text-white rounded-full text-base font-medium hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                <i className="ri-whatsapp-line mr-2 text-xl w-5 h-5 flex items-center justify-center"></i>
                WhatsApp Us
              </a>
            </div>

            <p className="text-xs text-white/50 mt-6" style={{ fontFamily: "'Inter', sans-serif" }}>
              +6012-3835600 • Instant confirmation
            </p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl w-8 h-8 flex items-center justify-center"></i>
      </div>
    </section>
  );
}
